<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_9"></a><a id="cont"></a>CONTENTS</h1>
<p class="toc"><a href="#/06_introduction#intro">Introduction: How to Use This Book</a></p>
<p style="text-align:center; margin-top:2pc"></p>
<p class="toc"><a href="#/07_chapter01#c01">Section 1: You're a New Manager, Now What?</a></p>
<p class="toc"><span href="#/08_chapter02#c02" title="Link target outside of Sample">Section 2: Developing Your Management Skills</span></p>
<p class="toc"><span href="#/09_chapter03#c03" title="Link target outside of Sample">Section 3: Building and Managing Your Team</span></p>
<p class="toc"><span href="#/10_chapter04#c04" title="Link target outside of Sample">Section 4: Creating Your Personal Brand</span></p>
<p class="toc"><span href="#/11_chapter05#c05" title="Link target outside of Sample">Section 5: Managing Up, Down, and Around</span></p>
<p class="toc"><span href="#/12_chapter06#c06" title="Link target outside of Sample">Section 6: Avoiding Potential Land Mines</span></p>
<p class="toc"><span href="#/13_chapter07#c07" title="Link target outside of Sample">Section 7: Recognizing Legal Pitfalls</span></p>
<p style="text-align:center; margin-top:2pc"></p>
<p class="toc"><span href="#/14_notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/15_resources#resou" title="Link target outside of Sample">Resources</span></p>
<p class="toc"><span href="#/16_glossary#gloss" title="Link target outside of Sample">Glossary of Management and Business Terms</span></p>
<p class="toc"><span href="#/17_abouttheauthor#auth" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?310ac84e